window.PredictiveSearchAuctionUtils = {
  buildAuctionUrl(auctionAppUrl, variantId, auctionStartTag) {
    if (!auctionAppUrl || !variantId) return null;

    const formattedDateTime = this.extractAuctionDateTimeFromTag(auctionStartTag);
    if (!formattedDateTime) return null;

    return `${auctionAppUrl}/auction/${variantId}/${formattedDateTime}?v=2`;
  },

  extractAuctionDateTimeFromTag(auctionStartTag) {
    if (!auctionStartTag) return null;

    let startDate = auctionStartTag;
    const startMatch = String(auctionStartTag).match(/^as:(.*)$/i);
    if (startMatch && startMatch[1]) {
      startDate = startMatch[1];
    }

    const isoMatch = startDate.match(/(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
    if (isoMatch) {
      return `${isoMatch[1]}T${isoMatch[2]}`;
    }

    const standardMatch = startDate.match(/(\d{4}-\d{1,2}-\d{1,2})\s+(\d{2}:\d{2})/);
    if (!standardMatch) {
      return null;
    }

    const [, year, month, day] = standardMatch[1].match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${standardMatch[2]}`;
  },
};